import React, { FC } from 'react';

// CONSTANT
import { LINKS } from 'constant';

export const AgreementLink: FC = ({ children }) => (
  <a href={LINKS.ProgrammeAgreement} rel="noopener noreferrer" target="_blank">
    <b className="linkText">{children}</b>
  </a>
);
